/**
 * My Events page translations
 * 
 * This file contains translations for the My Events page.
 */

import { MyEventsTranslationType } from './types';

// English translations
export const enMyEvents: MyEventsTranslationType = {
  myEvents: {
    title: "My Events",
    subtitle_one: "{{count}} event created",
    subtitle_other: "{{count}} events created",
    subtitleGuest_one: "{{count}} event opened on this device",
    subtitleGuest_other: "{{count}} events opened on this device",
    newEvent: "New Event",
    loading: "Loading...",
    loadMore: "Load More Events",
    pagination_one: "Showing {{showing}} of {{count}} event",
    pagination_other: "Showing {{showing}} of {{count}} events",
    paginationTotal: "of {{total}} total",
    authRequired: "Please sign in with Google to view your events.",
    filters: {
      search: "Search events...",
      searchAction: "Search",
      all: "All",
      active: "Active",
      closed: "Closed",
      roleAll: "All",
      roleOwner: "Mine",
      roleJoined: "Viewed",
      sortDate: "Date",
      sortName: "Name",
      sortTotal: "Total"
    },
    emptyState: {
      noEvents: {
        title: "No Events Yet",
        description: "Create your first event to start splitting expenses with friends, family, or colleagues.",
        button: "Create Your First Event"
      },
      noResults: {
        title: "No Events Found",
        description: "Try adjusting your search or filter criteria.",
        button: "Clear Filters"
      }
    },
    featured: {
      label: "Latest active event",
      participants_one: "{{count}} participant",
      participants_other: "{{count}} participants",
      expenses_one: "{{count}} expense",
      expenses_other: "{{count}} expenses",
      noExpenses: "No expenses yet",
      othersLabel: "All events"
    },    eventCard: {
      status: {
        closed: "Closed",
        new: "New",
        active: "Active"
      },
      participant: "participant{{s}}",
      expense: "expense{{s}}",
      participants: "Participants:",
      more: "+{{count}} more",
      loadingNames: "Loading names...",
      viewDetails: "View Details",
      copyLink: "Copy Link",
      share: "Share",
      copied: "Copied!",
      delete: "Delete",
      deleteConfirm: {
        title: "Delete \"{{name}}\"",
        message: "Are you sure you want to permanently delete this event and all its data?",
        cancel: "Cancel",
        confirm: "Delete"
      },
      removeConfirm: {
        title: "Remove \"{{name}}\"",
        message: "Are you sure you want to remove this event from your history? The actual event data will not be deleted.",
        cancel: "Cancel",
        confirm: "Remove"
      },
      deleteError: "Failed to delete event. Please try again."
    }
  }
};

// Vietnamese translations
export const viMyEvents: MyEventsTranslationType = {
  myEvents: {
    title: "Sự Kiện Của Tôi",
    subtitle_other: "{{count}} sự kiện đã tạo",
    subtitleGuest_other: "{{count}} sự kiện đã mở trên máy này",
    newEvent: "Sự Kiện Mới",
    loading: "Đang tải...",
    loadMore: "Tải Thêm Sự Kiện",
    pagination_other: "Hiển thị {{showing}} trong số {{count}} sự kiện",
    paginationTotal: "trên tổng {{total}}",
    authRequired: "Vui lòng đăng nhập bằng Google để xem sự kiện của bạn.",
    filters: {
      search: "Tìm kiếm sự kiện...",
      searchAction: "Tìm kiếm",
      all: "Tất cả",
      active: "Hoạt động",
      closed: "Đã đóng",
      roleAll: "Tất cả",
      roleOwner: "Của tôi",
      roleJoined: "Đã xem",
      sortDate: "Ngày",
      sortName: "Tên",
      sortTotal: "Tổng"
    },
    emptyState: {
      noEvents: {
        title: "Chưa Có Sự Kiện",
        description: "Tạo sự kiện đầu tiên của bạn để bắt đầu chia sẻ chi phí với bạn bè, gia đình hoặc đồng nghiệp.",
        button: "Tạo Sự Kiện Đầu Tiên"
      },
      noResults: {
        title: "Không Tìm Thấy Sự Kiện",
        description: "Hãy thử điều chỉnh tiêu chí tìm kiếm hoặc lọc.",
        button: "Xóa Bộ Lọc"
      }
    },
    featured: {
      label: "Sự kiện đang hoạt động mới nhất",
      participants_one: "{{count}} người",
      participants_other: "{{count}} người",
      expenses_one: "{{count}} khoản chi",
      expenses_other: "{{count}} khoản chi",
      noExpenses: "Chưa có khoản chi nào",
      othersLabel: "Tất cả sự kiện"
    },    eventCard: {
      status: {
        closed: "Đã Đóng",
        new: "Mới",
        active: "Đang Hoạt Động"
      },
      participant: "người tham gia",
      expense: "chi phí",
      participants: "Người tham gia:",
      more: "+{{count}} người khác",
      loadingNames: "Đang tải tên...",
      viewDetails: "Xem Chi Tiết",
      copyLink: "Sao Chép Liên Kết",
      share: "Chia Sẻ",
      copied: "Đã Chia Sẻ!",
      delete: "Xóa",
      deleteConfirm: {
        title: "Xóa \"{{name}}\"",
        message: "Bạn có chắc chắn muốn xóa vĩnh viễn sự kiện này cùng toàn bộ dữ liệu không?",
        cancel: "Hủy",
        confirm: "Xóa Dữ Liệu"
      },
      removeConfirm: {
        title: "Xóa khỏi danh sách \"{{name}}\"",
        message: "Bạn có chắc chắn muốn xóa sự kiện này khỏi lịch sử của bạn? (Dữ liệu sự kiện sẽ KHÔNG bị xóa).",
        cancel: "Hủy",
        confirm: "Xóa Khỏi Danh Sách"
      },
      deleteError: "Không thể xóa sự kiện. Vui lòng thử lại."
    }
  }
};